import React, { useState } from "react";
import {
  Container,
  Paper,
  Typography,
  Button,
  TextField,
  FormHelperText,
  InputLabel, 
  Input,
  Link,
  FormControl
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import validator from "validator";
import "../../../../common/style/main.css";
import { forgotPassword } from "./../../reducer/actions";
import { toast } from "react-toastify";
import ContentWrapper from "../../../../common/components/contentWrapper";
import { CircularProgress } from "@material-ui/core";

const RecoveryPasswordComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [emailId, setEmailId] = useState("");
  const [emailError, setEmailError] = useState("");

  const onEmailIdChange = (e) => {
    const value = e.target.value;

    if (!validator.isEmail(value)) {
      setEmailError("Enter Valid Email Id");
    } else {
      setEmailError("");
    }

    setEmailId(value);
  };

  const validateInput = () => {
    if (!emailId || !validator.isEmail(emailId)) {
      setEmailError("Enter Correct Email Id");
      return false;
    }
    return true;
  };

  const submitForm = () => {
    if (!validateInput()) return;

    const data = {
      email: emailId,
    };
    setLoading(true);
      forgotPassword(data, (error, res) => {
        setLoading(false);
        if (error) {
          toast("Something went wrong", {
          type: "error",
          position: "bottom-center",
        });
        } else {
            if (res?.success === 1) {
        //   toast(res.message || "Reset link sent successfully", {
        //     type: "success",
        //     position: "bottom-center",
        //   });
        history.push("/forgot-success", { email: emailId });
        } else {
          toast(res?.message || "Failed to send email", {
            type: "error",
            position: "bottom-center",
          });
        }
        }
      })
  };

  const contentView = (
    <div>
    <Container maxWidth="sm" 
        style={{
            minHeight: "70vh", 
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }}>
      {/* <Paper style={{ padding: "30px", width: "100%" }}> */}
      <Paper className="border-radius">
        <div style={{ background: "#383838", marginBottom:"15px", padding: "10px" }}>
        <Typography variant="h5" gutterBottom align="center" className="text-white">
          Recover Password
        </Typography>
        </div>
        <p style={{color: "#555", fontSize: "16px", textAlign: "center" }}>
          Please enter your email address and we will send you a link to reset your password.
        </p>

        <div style={{ display: "flex", alignItems: "center",
        gap: "10px",          
        padding: "0 20px",    
        marginTop: "20px"}}>
        <FormControl style={{ flex: 1 }}>
            <InputLabel htmlFor="component-simple"
            style={{
                color: "#9e9e9e",
                fontSize: "16px",
                letterSpacing: "1px",
            }}
            >
            EMAIL ID
            </InputLabel>
            <Input id="component-simple" onChange={onEmailIdChange}
             onKeyDown={(event) => event.key === 'Enter' ? submitForm() : null} />

          <FormHelperText className="error-o">
            {emailError}
          </FormHelperText>
        </FormControl>
        </div>

        <Button
         variant="contained"
          disabled={loading} 
          className="SubmitrecoverySuccess"
          style={{ marginLeft: "20px", marginBottom: "4px", minWidth: "510px", 
            height: "40px",    
            marginTop: "15px" }}
          onClick={submitForm}
        >
          {loading ? (
            <CircularProgress size={24} style={{ color: "white" }} />
          ) : (
            "Send"
          )}
        </Button>

        {/* <p
          align="center"
          style={{
            marginTop: "15px",
            cursor: "pointer",
            textDecoration: "underline",
            fontSize: "13px"
          }}
          onClick={() => history.push("/login")}
        >
          Back to Login
        </p> */}
        <div style={{ textAlign: "center", marginTop: "20px", marginBottom: "20px" }}>
         <Link href="/login" className="notVendorLink1">
           &nbsp;Back to login
         </Link>
         </div>

      </Paper>
    </Container>
    </div>
  );
  return <ContentWrapper contentView={contentView} />;
};

export default RecoveryPasswordComponent;
